module.exports = __webpack_public_path__ + "static/media/checkbox.cf268f67.svg";